type FieldInputType = 'text' | 'email' | 'number' | 'textarea' | 'select'
type FieldWidth = 'full' | 'half'
type SubmitAction = 'none' | 'sendEmail' | 'sendToCrm'

type ComposableFormTitle = {
  id: number
  as: string
  typo: string
  content: string
}

type ComposableFormField = {
  id: number
  inputId: string
  label: string
  placeholder: string | null
  inputType: FieldInputType
  requiredField: boolean
  width: FieldWidth | null
  dafaultValue: string | null
  hiddenField: boolean
  compileWithUrlParams: boolean
  selectOptions: string | null
}

type ComposableFormRawProps = {
  type: string
  sectionId: string | null
  withBackground: boolean
  colorScheme: string
  description: string
  crmId: string
  submitAction: SubmitAction
  successMessage: string
  submitLabel: string
  privacyLabel: string
  title: ComposableFormTitle
  fields: ComposableFormField[]
}

type ComposableFormNormalized = {
  type: string
  sectionId: string | null
  withBackground: boolean
  colorScheme: string
  description: string
  crmId: string
  submitAction: SubmitAction
  successMessage: string
  submitLabel: string
  privacyLabel: string
  title: ComposableFormTitle
  fields: ComposableFormField[]
}

const ComposableForm = ({
  type,
  sectionId,
  withBackground,
  colorScheme,
  description,
  crmId,
  submitAction,
  successMessage,
  submitLabel,
  privacyLabel,
  title,
  fields = [],
}: ComposableFormRawProps): ComposableFormNormalized => {
  const normalizedData: ComposableFormNormalized = {
    type,
    sectionId,
    withBackground,
    colorScheme,
    description,
    crmId,
    submitAction,
    successMessage,
    submitLabel,
    privacyLabel,
    title,
    fields,
  }

  return normalizedData
}

export default ComposableForm

export type {
  ComposableFormRawProps,
  ComposableFormNormalized,
  ComposableFormField,
  ComposableFormTitle,
  FieldInputType,
  FieldWidth,
  SubmitAction,
}
